import React from "react"
import tw from "twin.macro"
import { StaticImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"
import {
  GatsbyImage,
  getImage,
  IGatsbyImageData,
  ImageDataLike,
} from "gatsby-plugin-image"

const AboutmeData = [
  {
    name: "FULL NAME",
    answer: " ",
  },
  {
    name: "D.O.B.",
    answer: " ",
  },
  {
    name: "ADDRESS",
    answer: " ",
  },
  {
    name: "E-MAIL",
    answer: " ",
  },
  {
    name: "PHONE",
    answer: " ",
  },
  {
    name: "FREELANCE",
    answer: " ",
  },
]

const SkillData = [
  {
    title: "Language1",
    rate: 10,
  },
  {
    title: "Language2",
    rate: 10,
  },
  {
    title: "Language3",
    rate: 10,
  },
]
const proffesional = [
  {
    skill: "Skill 1",
    width: tw`w-1/2`,
    value: "50%",
  },
  {
    skill: "Skill 2",
    width: tw`w-10/12`,
    value: "80%",
  },
  {
    skill: "Skill 3",
    width: tw`w-4/12`,
    value: "30%",
  },
]

const ilist = [
  {
    name: "nesciunt tenetur",
  },
  {
    name: "nesciunt tenetur",
  },
  {
    name: "nesciunt tenetur",
  },
  {
    name: "nesciunt tenetur",
  },
]
type dataType = {
  allCheckJson: {
    nodes: {
      name: String
      image: ImageDataLike
    }[]
  }
}
const Aboutme = () => {
  const data: dataType = useStaticQuery(graphql`
    query cekQuery {
      allCheckJson {
        nodes {
          name
          image {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `)
  const AllData = data.allCheckJson.nodes
  return (
    <div>
      <div>
        {/* middle side */}
        <div tw="bg-white">
          <h1 tw=" ml-4 text-2xl font-semibold pt-6 pl-6">
            {" "}
            HELLO, I’M "NAME"!
          </h1>
          <h3 tw="mt-3 ml-4 mr-2.5 text-gray-700 text-lg pl-6 pt-4">
            "Brief description": Lorem ipsum dolor, sit amet consectetur
            adipisicing elit. Unde nesciunt tenetur, amet harum tempora cumque.
            Lorem ipsum dolor sit amet, consectetuer adipiscing is simply dummy
            text of the printing and typesetting industry ever since the 1500s.
          </h3>
          <button tw="bg-white hover:bg-gray-50 text-gray-800 font-semibold py-4 px-4 border border-blue-400 rounded-full shadow mt-4 ml-5">
            Share
          </button>
          <hr tw="mt-10" />
          <div tw="grid md:grid-cols-2 gap-2 p-6">
            <div tw="container">
              <h1 tw="text-lg text-gray-400	"> personal information</h1>
              <div tw="table-fixed pt-2">
                {AboutmeData.map((item, index) => (
                  <div tw="flex space-x-8">
                    <tr tw=" font-semibold text-sm p-1">{item.name}</tr>
                    <div>
                      <tr tw="pl-3 text-xs">{item.answer}</tr>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div tw="container">
              {SkillData.map((item, index) => (
                <>
                  <h1 tw="p-2 font-semibold">{item.title}</h1>
                  <span tw=" inline-flex space-x-2.5">
                    {[...Array(item.rate).keys()].map((_, index) => (
                      <span
                        key={index}
                        tw="rounded-full h-3 w-3 flex   bg-blue-300 "
                      ></span>
                    ))}
                  </span>
                </>
              ))}
            </div>
          </div>
          <hr />
          <div tw="grid md:grid-cols-2 gap-2 p-6 ">
            <h1 tw="text-lg text-gray-400">professional skills</h1>
            <div tw="container p-2 col-start-1 col-end-1">
              {proffesional.map((item, index) => (
                <div>
                  <div tw="grid grid-cols-4 gap-2 w-72">
                    <h2 tw="col-start-1 col-end-4 text-base font-semibold">
                      {item.skill}
                    </h2>
                    <h2 tw="col-start-4 col-end-4 text-base">{item.value}</h2>
                  </div>
                  <div>
                    <div tw="relative pt-1">
                      <div tw="overflow-hidden h-2 mb-4 w-56 flex rounded bg-blue-100">
                        <div
                          css={[item.width]}
                          tw=" flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <hr tw="mt-3" />
          {/* STYLE LIST */}
          <div tw="grid md:grid-cols-2 gap-2 p-8">
            <div tw="container">
              <h1 tw="text-lg text-gray-400">styled list</h1>
              <div tw="container pt-4">
                {AllData.map((item, index) => {
                  const image = getImage(item.image)
                  return (
                    <div>
                      <div tw="flex md:grid-cols-2 gap-2">
                        <div tw="col-start-1 col-end-1 p-1.5">
                          <GatsbyImage
                            image={image as IGatsbyImageData}
                            alt="photo"
                            tw="h-6 w-6"
                          />
                        </div>
                        <div tw="col-start-2 col-end-2 text-base font-semibold pt-1">
                          {item.name}
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            {/* ICONS LIST */}
            <div tw="container">
              <h1 tw="text-lg text-gray-400">icons list</h1>
              <div tw="container pt-2">
                {ilist.map((item, index) => (
                  <h1 tw="p-2">{item.name}</h1>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Aboutme
